export enum OrthogonalDirection {
  Up = 'Up',
  Right = 'Right',
  Down = 'Down',
  Left = 'Left',
}
